import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=517c48d5&"
import script from "./Importer.vue?vue&type=script&lang=js&"
export * from "./Importer.vue?vue&type=script&lang=js&"
import style0 from "./Importer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports